import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Usavisitvisaimport from "@/pages/usavisitvisaimport";
const Usavisitvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/usaimg.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        
        </div>
      </div>    
      <div className=" md:ml-32 mt-10 w-full md:w-3/4 text-center md:text-center text-3xl font-bold text-[#011473] drop-shadow-md">
  Visitor Visa to the U.S.
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/visita.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-10 lg:w-1/2">
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
     <a className="font-bold text-black"> Purpose:</a> Clear reason for travel, such as business, tourism, or family visit.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="font-bold text-black">Financial Proof:</a> Bank statements showing sufficient funds.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="font-bold text-black"> Return Intent:</a> Evidence of ties to home country ensuring return after visit.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="font-bold text-black">Health & Character:</a> Meet health standards and provide required documents.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="font-bold text-black">Legal Compliance:</a> Adhere to U.S. Immigration and Nationality Act (INA) rules.
    </span>
  </div>
</div>




      </div>
      <Usavisitvisaimport />
      
      <div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center text-black  rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        <strong>USA Visit Visa</strong>  
        <br />
        The United States is a top destination for travelers worldwide, offering a unique blend of cultural diversity, historical landmarks, scientific advancements and breathtaking landscapes. To enter the USA, visitors must obtain a USA Visit Visa. At Visa World, we provide expert guidance and support throughout the visa application process.  
        <br />
        <br />
        <strong>Types of USA Visit Visas</strong>  
        <br />
        - <strong>B1 Visa (Business Visits)</strong>  
        Designed for individuals traveling for business purposes.  
        Applicable for attending meetings, negotiating contracts, or participating in non-recreational seminars and international conferences.  
        Ideal for short-term visits with a clear business agenda.  
        <br />
        - <strong>B2 Visa (Tourism and Personal Visits)</strong>  
        Intended for tourism, leisure trips, visiting family, or receiving medical treatment.  
        Focused on non-business-related travel needs.  
        <br />
        <br />
        <strong>Why Choose Visa World?</strong>  
        <br />
        - Comprehensive assistance with documentation and application filing.  
        - Expert advice tailored to your travel purpose.  
        - Reliable support for a smooth and efficient visa process.  
        <br />
        Embark on your journey to the USA with confidence—let Visa World handle the complexities of your visit visa application!  
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Learn About USA Visit Visas
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>





      <Contacts />
    </>
  );
};

export default Usavisitvisa;
